import React from 'react';

const Header = ({ children }) => (
  <header>
    <div className="inner">{children}</div>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js